import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";
var _Table$Cell, _Table$Cell2, _a;
/*
 * Copyright (C) 2019 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react';
import { bool, func } from 'prop-types';
import { Heading } from '@instructure/ui-heading';
import { Text } from '@instructure/ui-text';
import { Table } from '@instructure/ui-table';
import { Modal } from '@instructure/ui-modal';
import { CloseButton } from '@instructure/ui-buttons';
import { View } from '@instructure/ui-view';
import formatMessage from '../format-message';
import { determineOSDependentKey } from './userOS';
import { instuiPopupMountNodeFn } from '../util/fullscreenHelpers';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
export default function KeyboardShortcutModal(props) {
  const OSKey = determineOSDependentKey();
  return /*#__PURE__*/_jsx(Modal, {
    "data-testid": "RCE_KeyboardShortcutModal",
    "data-mce-component": true,
    label: formatMessage('Keyboard Shortcuts'),
    mountNode: instuiPopupMountNodeFn,
    open: props.open,
    shouldCloseOnDocumentClick: true,
    shouldReturnFocus: true,
    size: "auto",
    onClose: props.onClose,
    onExited: props.onExited,
    onDismiss: props.onDismiss
  }, void 0, /*#__PURE__*/_jsx(Modal.Header, {}, void 0, /*#__PURE__*/_jsx(CloseButton, {
    placement: "end",
    offset: "medium",
    color: "primary",
    onClick: props.onDismiss,
    screenReaderLabel: formatMessage('Close')
  }), /*#__PURE__*/_jsx(Heading, {}, void 0, formatMessage('Keyboard Shortcuts'))), /*#__PURE__*/_jsx(Modal.Body, {}, void 0, /*#__PURE__*/_jsx(View, {
    as: "div",
    padding: "x-small xx-large large x-large"
  }, void 0, /*#__PURE__*/_jsx(Table, {
    margin: "small",
    caption: formatMessage('Keyboard Shortcuts')
  }, void 0, /*#__PURE__*/_jsx(Table.Head, {}, void 0, /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.ColHeader, {
    id: "shortcut_header"
  }, void 0, /*#__PURE__*/_jsx(ScreenReaderContent, {}, void 0, formatMessage('Shortcut'))), /*#__PURE__*/_jsx(Table.ColHeader, {
    id: "description_header"
  }, void 0, /*#__PURE__*/_jsx(ScreenReaderContent, {}, void 0, formatMessage('Description'))))), /*#__PURE__*/_jsx(Table.Body, {}, void 0, /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, OSKey, "+F8")), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage('Open this keyboard shortcuts dialog'))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, formatMessage('SHIFT+Arrows'))), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage('Highlight an element to activate the element options toolbar'))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, _Table$Cell || (_Table$Cell = /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, "CTRL+F9"))), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage('Focus element options toolbar'))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, OSKey, "+F9")), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage("Go to the editor's menubar"))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, OSKey, "+F10")), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage("Go to the editor's toolbar"))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, _Table$Cell2 || (_Table$Cell2 = /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, "ESC"))), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage('Close a menu or dialog. Also returns you to the editor area'))), /*#__PURE__*/_jsx(Table.Row, {}, void 0, /*#__PURE__*/_jsx(Table.Cell, {}, void 0, /*#__PURE__*/_jsx(Text, {
    weight: "bold"
  }, void 0, formatMessage('TAB/Arrows'))), /*#__PURE__*/_jsx(Table.Cell, {}, void 0, formatMessage('Navigate through the menu or toolbar'))))), /*#__PURE__*/_jsx(View, {
    as: "p",
    padding: "large 0 0 0",
    margin: "0 0 0 small"
  }, void 0, formatMessage('Other editor shortcuts may be found at'), ' ', _a || (_a = /*#__PURE__*/_jsx("a", {
    href: "https://www.tiny.cloud/docs/advanced/keyboard-shortcuts/",
    target: "rcekbshortcut"
  }, void 0, "https://www.tiny.cloud/docs/advanced/keyboard-shortcuts/"))))));
}